import { memo, useEffect, useState, VFC } from 'react'
import ReactSlick, { Settings as ReactSlickSettings } from 'react-slick'
import { postInterested } from 'src/api/recommendation'
import { DEFAULT_IMAGE } from 'src/assets/images'
import {
  LeftBorderRoundedArrowIcon,
  RightBorderRoundedArrowIcon,
} from 'src/assets/svgs'
import { truewhite } from 'src/styles/colors'
import { WIDTH_THRESHOLD } from 'src/styles/mixins'
import styled from 'styled-components'
import { RequestReasonModal } from '../RequestReasonModal'
import { Section } from './styles'
import { ProfilePreviewProps } from './types'

export const ConnectionCompaniesSection: VFC<ProfilePreviewProps> = memo(
  ({
    user: {
      company: { connectionCompanies, connectionCount },
    },
    mutate,
  }) => {
    const [showReasonModal, setShowReasonModal] = useState<boolean>(false)
    const [showRequestProfileId, _] = useState<number>(0)

    // const onClickContact = async (id: number) => {
    //   setShowReasonModal(true)
    //   setShowRequestProfileId(id)
    // }
    const onPostInterested = async (reason: string, detail: string) => {
      await postInterested(showRequestProfileId, reason, undefined, detail)
      mutate && mutate()
      setShowReasonModal(false)
    }

    const [width, setWidth] = useState(window.innerWidth)
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth)
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])

    if (!connectionCompanies || connectionCompanies.length === 0) return <></>

    // API の connection_count を優先（配列長は閲覧者除外などで件数とズレるため）
    const connectionHeadcount =
      connectionCount != null ? connectionCount : connectionCompanies.length

    const isTab = width < WIDTH_THRESHOLD
    const slidesToShowCount = isTab ? 1 : 4
    const canShowArrows = connectionCompanies.length > slidesToShowCount
    const slidesToShow = Math.min(slidesToShowCount, connectionCompanies.length)
    const slidesToScroll = slidesToShowCount

    return (
      <>
        <Section>
          <h3>つながり {connectionHeadcount}人</h3>
          <ConnectionCompaniesWrapper>
            <ReactSlick
              arrows={canShowArrows}
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              {...settings}
            >
              {connectionCompanies.map((company) => (
                <SlickItem key={company.id}>
                  <ConnectionCompany>
                    <ItemContentImage
                      src={company.imageUrl || DEFAULT_IMAGE}
                      alt={company.name}
                      onError={(e) => {
                        const img = e.currentTarget
                        if (img.src !== DEFAULT_IMAGE) img.src = DEFAULT_IMAGE
                      }}
                    />
                    <CompanyName>{company.name}</CompanyName>
                    <CompanyAdminName>{company.adminName}</CompanyAdminName>
                    {/* NOTE: OS-1543 で非表示対応を行った */}
                    {/* {company.matchingStatus === null ? (
                      <SubmitButton onClick={() => onClickContact(company.id)}>
                        コンタクト
                      </SubmitButton>
                    ) : company.matchingStatus === 'request' ||
                      company.matchingStatus === 'not_interest' ||
                      company.matchingStatus === 'be_rejected' ? (
                      <SubmittedButton disabled>つながり申請済</SubmittedButton>
                    ) : company.matchingStatus === 'matched' ||
                      company.matchingStatus === 'sended' ? (
                      <ConnectedButton disabled>つながり済</ConnectedButton>
                    ) : (
                      <></>
                    )} */}
                  </ConnectionCompany>
                </SlickItem>
              ))}
            </ReactSlick>
          </ConnectionCompaniesWrapper>
        </Section>
        {showReasonModal && showRequestProfileId !== 0 && (
          <RequestReasonModal
            postInterested={(reason, detail) =>
              onPostInterested(reason || '', detail)
            }
            close={() => setShowReasonModal(false)}
          />
        )}
      </>
    )
  },
)

const ConnectionCompaniesWrapper = styled.div`
  max-width: 700px;
  width: 100%;
  padding: 20px 40px;
  background-color: ${truewhite};
  border-radius: 10px;

  .slick-arrow {
    font-size: 3em;
    :hover {
      opacity: 0.5;
      color: inherit;
    }
    width: 1em;
    height: 1em;
    &.slick-prev {
      // left: 89%;
      // top: -18%;
    }
    &.slick-next {
      // right: 2%;
      // top: -18%;
    }
  }
  .slick-slide {
  }
`
const settings: ReactSlickSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  centerMode: false,
  initialSlide: 1,
  nextArrow: <LeftBorderRoundedArrowIcon />,
  prevArrow: <RightBorderRoundedArrowIcon />,
}
const SlickItem = styled.div`
  max-width: 163px;
  width: 100% !important;
  margin: 0 auto;
`
const ConnectionCompany = styled.div`
  margin: 0 25px;
`
const ItemContentImage = styled.img`
  border-radius: 50%;
  object-fit: cover;
  width: 100%;
  height: 107px;
`
const CompanyName = styled.p`
  padding-top: 8px;
  font-size: 10px;
  padding-bottom: 4px;
`
const CompanyAdminName = styled.p`
  font-size: 16px;
`
// const ButtonCss = css`
//   color: ${white};
//   margin-top: 8px;
//   padding: 6px 12px;
//   width: 100%;
//   height: 29px;

//   :disabled {
//     cursor: not-allowed;
//   }
// `
// const SubmitButton = styled(SmallButton)`
//   ${ButtonCss}
//   background-color: ${_messagebuttonbg};
// `
// const SubmittedButton = styled(SmallButton)`
//   ${ButtonCss}
//   background-color: ${lightgray};
// `
// const ConnectedButton = styled(SmallButton)`
//   ${ButtonCss}
//   background-color: ${orange};
// `
